import type { InputHTMLAttributes, ReactNode, SelectHTMLAttributes } from 'react';
import { useId } from 'react';
import styles from './form.module.css';

export function Field({
  label,
  error,
  children,
  htmlFor,
}: {
  label: string;
  error?: string | null;
  children: (id: string) => ReactNode;
  htmlFor?: string;
}) {
  const generated = useId();
  const id = htmlFor ?? generated;
  return (
    <div className={styles.field}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      {children(id)}
      {error ? (
        <span className={styles.error} role="alert">
          {error}
        </span>
      ) : null}
    </div>
  );
}

type InputProps = InputHTMLAttributes<HTMLInputElement>;
export function Input({ className, ...rest }: InputProps) {
  return (
    <input className={[styles.control, className ?? ''].filter(Boolean).join(' ')} {...rest} />
  );
}

type SelectProps = SelectHTMLAttributes<HTMLSelectElement> & { inline?: boolean };
export function Select({ className, inline, ...rest }: SelectProps) {
  const cls = [styles.control, inline ? styles.inline : '', className ?? '']
    .filter(Boolean)
    .join(' ');
  return <select className={cls} {...rest} />;
}
